import axios from 'axios';
import SweetAlert from 'sweetalert2';
import { apiEndpoints } from '../../../config';

export const printFicheClient = async (
  CodAgce2: string,
  Libelle: string,
  Banque: string,
  Teleph: string,
  NumReg: string,
  Licence: string,
  NumCon: string,
  BPoste: string,
  Ville: string,
  NomUser: string,
  NumCli: string,
  format: string = 'PDF',
) => {
  try {
    const response = await axios.get(`${apiEndpoints.fastReport}/module-clients`, {
      params: {
        CodAgce2,
        Libelle,
        Banque,
        Teleph,
        NumReg,
        Licence,
        NumCon,
        BPoste,
        Ville,
        NomUser,
        ListAgce: CodAgce2,
        NumCliD: NumCli,
        NumCliF: NumCli,
        DateDebut: '1900-01-01',
        DateFin: '2100-12-31',
        Type: 'FICHE',
        format,
      },
      responseType: 'blob',
    });

    if (response.data) {
      const isPdf = format.toUpperCase() === 'PDF';
      const mimeType = isPdf
        ? 'application/pdf'
        : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const blob = new Blob([response.data], { type: mimeType });
      const now = new Date();
      const formattedDate = now.toLocaleDateString('fr-FR').replace(/\//g, '-');
      const formattedTime = now.toLocaleTimeString('fr-FR').replace(/:/g, '-');
      const fileName = `FicheClient_${NumCli}_${formattedDate}_${formattedTime}.${format.toLowerCase()}`;
      const url = window.URL.createObjectURL(blob);

      SweetAlert.fire({
        title: 'Fiche client générée',
        text: 'Souhaitez-vous prévisualiser, imprimer ou télécharger le fichier ?',
        icon: 'question',
        showCancelButton: true,
        showDenyButton: true,
        denyButtonText: 'Imprimer',
        confirmButtonText: 'Prévisualiser',
        cancelButtonText: 'Télécharger',
      }).then((result) => {
        const file = new File([blob], fileName, { type: mimeType });
        const fileUrl = URL.createObjectURL(file);

        if (result.isConfirmed) {
          window.open(fileUrl, '_blank');
        } else if (result.isDenied) {
          if (!isPdf) {
            const link = document.createElement('a');
            link.href = fileUrl;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            return;
          }
          const printHtml = `
       <html>
         <head>
           <title>${fileName}</title>
           <style>
             html, body {
               margin: 0;
               height: 100%;
             }
             iframe {
               width: 100%;
               height: 100%;
               border: none;
             }
           </style>
         </head>
         <body>
           <iframe id="pdfFrame" src="${fileUrl}"></iframe>
           <script>
             const iframe = document.getElementById('pdfFrame');
             iframe.onload = function() {
               setTimeout(() => {
                 iframe.contentWindow.focus();
                 iframe.contentWindow.print();
               }, 500);
             };
           </script>
         </body>
       </html>
     `;
          const printBlob = new Blob([printHtml], { type: 'text/html' });
          const printUrl = URL.createObjectURL(printBlob);
          window.open(printUrl, '_blank');
        } else {
          const link = document.createElement('a');
          link.href = fileUrl;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      });
    }
  } catch (error) {
    console.error('Erreur lors du téléchargement du fichier :', error);
    let message = String(error);
    if (axios.isAxiosError(error) && error.response?.data instanceof Blob) {
      try {
        const json = JSON.parse(await error.response.data.text());
        if (json?.errors) {
          message = Object.entries(json.errors)
            .map(([field, msgs]: [string, any]) => `${field}: ${(msgs as string[]).join(', ')}`)
            .join('\n');
        } else if (json?.title) {
          message = json.title;
        }
      } catch { /* la réponse n'est pas du JSON */ }
    }
    SweetAlert.fire({ title: 'Erreur', text: message, icon: 'error' });
  }
};
